import {
  Box,
  Button,
  Card,
  HStack,
  Spinner,
  Stack,
  Text,
  Image,
  Wrap,
  WrapItem,
  IconButton,
  Tooltip,
} from '@mybridge/ui';
import moment from 'moment';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { MyNetworkContext, MyNetworkProvider } from 'v4/components/network/context';
import { MyNetworkUserCard } from 'v4/components/network/network-card-full';
import { MatrixContext } from 'packages/mybridgev4/context/chat-context';
import { isMobile } from 'react-device-detect';
import { AcceptNewIcon, IgnoreNewIcon } from '@mybridge/icons';
import {MyNetworkCircleCardMenu} from '../../../profile/network/circle-menu';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { trimStr } from 'v4/components/utils';
import { NetworkListingNotFound } from '../../404';
import InfiniteScroll from 'react-infinite-scroll-component';

export const MyNetworkPendingInvitationsListing = forwardRef(
  ({limit, onShowAll, ...props }, ref) => {
    const {
      refetchPendingInvitations,
      pendingInvitations,
      pendingInvitationsIsLoading,
      pendingInvitationsIsFetching,
      acceptInvitation,
      acceptInvitationLoading,
      removeHandshakeRequestDisc,
      selectedUser,
      setSelectedUser,
      pendingInvitationsCount,
      moreSuggestionModalDisc,
      suggestionType,
      setSuggestionType,
      pendingInvitationsHasNextPage,
      pendingInvitationsFetchNextPage,
    } = useContext(MyNetworkContext);
    const { matrixClient } = useContext(MatrixContext);
    const { t } = useTranslator();
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
      refetchPendingInvitations?.();
    }, []);

    useEffect(() => {
      onShowAll?.(showAll);
    }, [showAll]);
  

    const handleRejectInvitation = (pi) => {
      setSelectedUser(pi);
      removeHandshakeRequestDisc?.onOpen?.();
    };

    const acceptRoomInvite = async (data) => {
      if (matrixClient && data?.chat_room_id) {
        try {
          const res = await matrixClient.joinRoom(data.chat_room_id);

        } catch (error) {
          console.error('Error joining the room:', error);
        }
      } else {
        console.error('matrixClient or chat_room_id is null or undefined');
      }
    };

    const loading = pendingInvitationsIsFetching || pendingInvitationsIsLoading;

    // Determine the invitations to display based on the showAll state
    // const displayedInvitations = pendingInvitations?.slice(0, limit);
    const displayedInvitations = showAll
      ? pendingInvitations
      : pendingInvitations?.slice(0, limit || 6);
    
    return (
      <>
       <MyNetworkProvider follower={true}>
        <Stack spacing={3}>
          {/* {loading && (
            <HStack justifyContent="center">
              <Spinner />
            </HStack>
          )} */}

          {pendingInvitations?.length ? (
            <>
              {/* Show the "Show All" button if there are more than 6 invitations and we're not showing all */}
              {pendingInvitations?.length > 6 && !showAll && (
                <HStack justifyContent="flex-end">
                  <Button
                    variant="transparent"
                    color="#868585"
                    onClick={() => setShowAll(true)}
                  >
                    {t('profileTestimonials.showAll') || "Show All"} ({pendingInvitationsCount})
                  </Button>
                </HStack>
              )}
              {/*
              <Wrap spacing={["2","0"]} justifyContent="center">
                {displayedInvitations?.map((pi, piIndex) => (
                  pi && pi?.user_info && <WrapItem key={piIndex} w={['100%', '49%']} p={3}>
                    <MyNetworkUserCard
                      user={pi?.user_info}
                      from={props?.from}
                      createdAt={pi?.created_at}
                      key={piIndex}
                      flexWrap={isMobile ? true : false}
                      isInvitations
                      cardHeight="auto"
                      actions={
                        <HStack justifyContent={["center","flex-start"]} >
                          <Tooltip label={'Reject invite' || t('profileNetwork.ignore') || "Ignore"}>
                            <IconButton
                              onClick={() => handleRejectInvitation(pi)}
                              bg="none"
                              width="30px"
                              height="40px"
                              borderRadius="50%"
                              border="1px solid #00000033"
                              icon={<IgnoreNewIcon />}
                            />
                          </Tooltip>

                          <Tooltip label={'Accept invite' || t('profileNetwork.accept') || "Accept"}>
                            <IconButton
                            bg="none"
                            width="30px"
                            height="40px"
                            borderRadius="50%"
                            border="1px solid #00000033"
                              isLoading={
                                selectedUser?.id === pi?.id &&
                                acceptInvitationLoading
                              }
                              onClick={() => {
                                setSelectedUser(pi);
                                acceptInvitation(pi);
                                // acceptRoomInvite(pi);
                              }}
                              icon={<AcceptNewIcon />}
                            />
                          </Tooltip>
                          <MyNetworkCircleCardMenu user={pi?.user_info} />
                        </HStack>
                      }
                    >
                      {pi?.message?.length ? (
                        <Box
                          mt={3}
                          mb={4}
                          p={2}
                          border="1px solid"
                          borderColor="#E4E6EB"
                          borderRadius="8px"
                        >
                          <Tooltip label={pi?.message}>
                            <Text fontSize="12px" color="#868585">
                              {trimStr(pi?.message, 10)}
                            </Text>
                          </Tooltip>
                        </Box>
                      ) : null}
                    </MyNetworkUserCard>
                  </WrapItem>
                ))}
              </Wrap>
              */}
              <InfiniteScroll
                dataLength={displayedInvitations?.length || 0}
                next={pendingInvitationsFetchNextPage}
                hasMore={!!pendingInvitationsHasNextPage}
                loader={
                  pendingInvitationsIsFetching ? (
                    <HStack p={4} justifyContent="center" w="100%">
                      <Spinner />
                    </HStack>
                  ) : null
                }
                scrollableTarget="pendingInvitationsContainer"
              >
                <Wrap
                  id="pendingInvitationsContainer"
                  spacing={["2","0"]}
                  justifyContent="center"
                  overflow="auto"
                  maxHeight="75vh"
                  sx={{
                    scrollbarWidth: 'none', 
                    '&::-webkit-scrollbar': {
                      display: 'none',
                    },
                  }}
                >
                  {displayedInvitations?.map((pi, piIndex) => (
                    pi && pi?.user_info && <WrapItem key={piIndex} w={['100%', '49%']} p={3}>
                      <MyNetworkUserCard
                        user={pi?.user_info}
                        from={props?.from}
                        createdAt={pi?.created_at}
                        key={piIndex}
                        flexWrap={isMobile ? true : false}
                        isInvitations
                        cardHeight="auto"
                        actions={
                          <HStack justifyContent={["center","flex-start"]} >
                            <Tooltip label={'Reject invite' || t('profileNetwork.ignore') || "Ignore"}>
                              <IconButton
                                onClick={() => handleRejectInvitation(pi)}
                                bg="none"
                                width="30px"
                                height="40px"
                                borderRadius="50%"
                                border="1px solid #00000033"
                                icon={<IgnoreNewIcon />}
                              />
                            </Tooltip>

                            <Tooltip label={'Accept invite' || t('profileNetwork.accept') || "Accept"}>
                              <IconButton
                              bg="none"
                              width="30px"
                              height="40px"
                              borderRadius="50%"
                              border="1px solid #00000033"
                                isLoading={
                                  selectedUser?.id === pi?.id &&
                                  acceptInvitationLoading
                                }
                                onClick={() => {
                                  setSelectedUser(pi);
                                  acceptInvitation(pi);
                                  // acceptRoomInvite(pi);
                                }}
                                icon={<AcceptNewIcon />}
                              />
                            </Tooltip>
                            <MyNetworkCircleCardMenu user={pi?.user_info} />
                          </HStack>
                        }
                      >
                        {pi?.message?.length ? (
                          <Box
                            mt={3}
                            mb={4}
                            p={2}
                            border="1px solid"
                            borderColor="#E4E6EB"
                            borderRadius="8px"
                          >
                            <Tooltip label={pi?.message}>
                              <Text fontSize="12px" color="#868585">
                                {trimStr(pi?.message, 10)}
                              </Text>
                            </Tooltip>
                          </Box>
                        ) : null}
                      </MyNetworkUserCard>
                    </WrapItem>
                  ))}
                </Wrap>
              </InfiniteScroll>
            </>
          ) : (
            !loading && (
              <HStack justifyContent="center">
                <Stack alignItems="center">
                  <NetworkListingNotFound />
                  <Text>{t('profileNetwork.noPendingInvitations') || "No pending invitations"}</Text>
                </Stack>
              </HStack>
              // <HStack justifyContent="flex-start">
              //   <Text>{t('profileNetwork.noPendingInvitations') || "No pending invitations"}</Text>
              // </HStack>
            )
          )}
        </Stack>
        </MyNetworkProvider>
      </>
    );
  }
);
